export default "__VITE_ASSET__c725e242__"